import styled, { css } from 'styled-components';
// TODO: remove material dependency and instead create our custom components
import { Avatar, Paper } from '@mui/material';
import { createGlobalStyle } from 'styled-components';

const ChatWindowComponentPaper = styled(Paper)`
    position: relative;
    overflow-y: auto;
    padding: 16px;
    max-height: 500px;
    height: ${props => props.$height || '480px'};
    max-height: ${props => props.$height || '480px'};
    box-shadow: ${props => props.boxShadow || 'none'} !important;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
`;

const ChatWindowAvatar = styled(Avatar)`
    margin-right: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const MessageContainer = styled.div`
    margin-bottom: 16px;
    display: flex;
    width: ${props => props.width || '70%'};
    align-items: flex-start;
`;

const flexWrapperStyles = css`
    display: flex;
`;

const normalWrapperStyles = css`
    display: block;
`;

const MessageWrapper = styled.div`
    padding: 12px 16px;
    border-radius: 16px;
    width: 100%;
    position: relative;
    transition: all 0.2s ease;
    
    ${props => props.itemType === 'sent' ? `
        background: linear-gradient(135deg, #2F80ED, #2F80ED);
        color: white;
        border-bottom-right-radius: 4px;
        margin-left: auto;
        box-shadow: 0 2px 4px rgba(47, 128, 237, 0.6);
        
        &:hover {
            box-shadow: 0 4px 8px rgba(47, 128, 237, 0.2);
        }
    ` : `
        background: white;
        color: #333333;
        border-bottom-left-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        
        &:hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
    `}

    > * {
        margin: 0;
        font-size: 0.95rem;
        font-family: "Inter", sans-serif;
        line-height: 1.5;
    }

    .markdown-content, .html-content {
        width: 100%;
        overflow-x: auto;
        
        table {
            border-collapse: collapse;
            width: 100%;
            margin: 8px 0;
            border-radius: 8px;
            overflow: hidden;

            th, td {
                border: 1px solid ${props => props.theme.colors.silverGrayTwo};
                padding: 8px 12px;
                text-align: left;
            }

            th {
                background-color: #F8F9FA;
            }
        }

        pre {
            background-color: #F8F9FA;
            padding: 12px;
            border-radius: 8px;
            overflow-x: auto;
            margin: 8px 0;
        }

        code {
            background-color: #F8F9FA;
            padding: 2px 6px;
            border-radius: 4px;
            font-family: 'Fira Code', monospace;
            font-size: 0.9em;
        }

        p {
            margin: 4px 0;
        }

        ul, ol {
            margin: 8px 0;
            padding-left: 24px;
        }

        li {
            margin: 4px 0;
        }

        blockquote {
            border-left: 4px solid #E0E0E0;
            margin: 8px 0;
            padding: 4px 12px;
            color: #666;
        }
    }

    ${props => props.$flex ? flexWrapperStyles : normalWrapperStyles}

    .streaming-message {
        position: relative;
    }

    .typing-cursor {
        display: inline-block;
        width: 2px;
        height: 15px;
        background-color: #000;
        margin-left: 2px;
        animation: blink 1s infinite;
    }

    .typing-indicator {
        display: flex;
        gap: 4px;
        padding: 8px 12px;
        background: #F0F0F0;
        border-radius: 12px;
        width: fit-content;

        span {
            width: 6px;
            height: 6px;
            background: #666;
            border-radius: 50%;
            animation: bounce 1.4s infinite ease-in-out;

            &:nth-child(1) { animation-delay: -0.32s; }
            &:nth-child(2) { animation-delay: -0.16s; }
        }
    }

    @keyframes blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
    }

    @keyframes bounce {
        0%, 80%, 100% { transform: translateY(0); }
        40% { transform: translateY(-4px); }
    }
`;

const MessageButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-top: ${props => props.mt ||'20px'};
    align-items: center;

    a {
        cursor: pointer;
    }
`;

const EditMessageWrapper = styled.div`
    padding: 12px;
    border-radius: 12px;
    width: 100%;
    color: ${props => props.theme.colors.primary};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    > * {
        margin: 0;
    }
`;

const EditMessageText = styled.div`
    ${props => props.theme.fonts.variant.light};
    font-size: ${props => props.theme.fonts.size.medium};
    color: ${props => props.theme.colors.black};
    text-align: center;
`;

const EditMessageInput = styled.textarea`
    resize: none;
    padding: 5px 10px;
    border-radius: 10px;

    &:focus {
        outline: none;
    }
`
const EditMessageInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${props => props.theme.colors.primary};
`;

const SpinnerImage = styled.img`
    height: 30px;
    margin-left:5px;
    opacity: 0.5;
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const ChatStyles = createGlobalStyle`
  .gfm-table {
    border-collapse: collapse;
    margin: 1em 0;
    width: 100%;
  }

  .gfm-th,
  .gfm-td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  .gfm-th {
    background-color: #f5f5f5;
    font-weight: bold;
  }

  .gfm-tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  .gfm-link {
    color: #0366d6;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .gfm-checkbox {
    margin-right: 6px;
    cursor: default;
  }

  .task-list-item {
    list-style-type: none;
  }

  // Enhanced GFM styles
  .gfm-strikethrough {
    text-decoration: line-through;
  }

  .gfm-task-list-item {
    list-style-type: none;
    margin-left: -20px;
    
    input[type="checkbox"] {
      margin-right: 8px;
    }
  }

  .gfm-table {
    border-collapse: collapse;
    margin: 1em 0;
    width: 100%;
    
    th, td {
      border: 1px solid #ddd;
      padding: 8px 12px;
    }

    th {
      background-color: #f5f5f5;
      font-weight: bold;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }
  }

  // Code block styling
  pre {
    background-color: #f6f8fa;
    border-radius: 6px;
    padding: 16px;
    overflow: auto;
  }

  code {
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 85%;
    padding: 0.2em 0.4em;
    margin: 0;
    background-color: rgba(27, 31, 35, 0.05);
    border-radius: 6px;
  }

  // Footnotes
  .footnotes {
    border-top: 1px solid #ddd;
    margin-top: 20px;
    padding-top: 16px;
  }

  .footnote-ref {
    font-size: 0.8em;
    vertical-align: super;
  }

  // Links
  .gfm-link {
    color: #0366d6;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export {
    ChatWindowComponentPaper,
    ChatWindowAvatar,
    MessageContainer,
    MessageWrapper,
    MessageButtonsWrapper,
    EditMessageWrapper,
    EditMessageText,
    EditMessageInput,
    EditMessageInputWrapper,
    SpinnerImage,
    ImageWrapper
}
